const OWNER_EMAIL = 'info@oldalexhub.com';

function apiBaseUrl() {
  let base = process.env.REACT_APP_API_BASE_URL || '/api/v1';
  if (typeof window === 'undefined') return base;

  if (
    base === '/api/v1' &&
    ['taxi-ops.com', 'www.taxi-ops.com'].includes(window.location.hostname)
  ) {
    base = 'https://saas-back-t7cj.onrender.com/api/v1';
  }

  try {
    const parsed = new URL(base, window.location.origin);
    if (
      parsed.hostname === 'localhost' &&
      window.location.hostname &&
      window.location.hostname !== 'localhost' &&
      window.location.hostname !== '127.0.0.1'
    ) {
      parsed.hostname = window.location.hostname;
      return parsed.toString().replace(/\/+$/, '');
    }
  } catch (_error) {
    return base;
  }

  return base;
}

async function request(path, options = {}) {
  const response = await fetch(`${apiBaseUrl()}${path}`, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
    ...options,
  });

  let payload = null;
  try {
    payload = await response.json();
  } catch (_error) {
    payload = null;
  }

  if (!response.ok) {
    const message = payload?.message || `Request failed with status ${response.status}.`;
    const error = new Error(message);
    error.status = response.status;
    error.payload = payload;
    throw error;
  }

  return payload;
}

export async function ownerLogin({ email, password }) {
  await request('/admins/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });

  const profile = await getCurrentAdmin();
  if (profile?.role !== 'owner' || profile?.email !== OWNER_EMAIL) {
    await ownerLogout();
    const signedInEmail = profile?.email || 'unknown email';
    const signedInRole = profile?.role || 'missing role';
    const error = new Error(
      `This portal is restricted to ${OWNER_EMAIL}. The server returned ${signedInEmail} with role "${signedInRole}".`,
    );
    error.status = 403;
    throw error;
  }

  return profile;
}

export function ownerLogout() {
  return request('/admins/logout', { method: 'POST' }).catch(() => null);
}

export function getCurrentAdmin() {
  return request('/admins/me');
}

export function getOwnerDashboard(params = {}) {
  const search = new URLSearchParams(params);
  const suffix = search.toString() ? `?${search.toString()}` : '';
  return request(`/owner/dashboard${suffix}`);
}

export { OWNER_EMAIL };
